import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'

import SettingsLayoutView from '../components/view/SettingsLayoutView'
import { getSchools, updateLayoutSchool } from '../store/school/actions'
import { roles } from '../utils/constants'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%'
  }
}))

const mapStateToProps = ({ auth, school }) => {
  return {
    schoolsList: school.list,
    userOccupations: auth.currentOccupation
  }
}

const mapDispatchToProps = {
  getSchools,
  updateLayoutSchool
}

const SettingsLayoutPage = ({
  getSchools,
  schoolsList,
  updateLayoutSchool,
  userOccupations
}) => {
  const isAdmin = userOccupations?.includes(roles.VERSAR_ADMIN)
  const classes = useStyles()

  useEffect(
    () => {
      isAdmin && getSchools()
    },
    [isAdmin]
  )

  return (
    <div className={classes.root}>
      <SettingsLayoutView
        updateLayoutSchool={updateLayoutSchool}
        schoolsList={schoolsList}
        isAdmin={isAdmin}
      />
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(SettingsLayoutPage)
